/* eslint-disable camelcase */
export class OmneoPortal {
  static ENDPOINT__EMAIL = '/api/auth/email'
  static ENDPOINT__SMS_RETRIEVE = '/api/auth/sms/retrieve'
  static ENDPOINT__SMS = '/api/auth/sms'
  static ENDPOINT__AVAILABILITY = '/api/auth/availability'
  static ENDPOINT__CREATE = '/api/auth/create'

  tenant

  constructor(tenant) {
    this.tenant = tenant
  }

  generateHeaders() {
    return new Headers({
      'Content-Type': 'application/json',
      Authorization: 'Bearer WaTmAMFXWl1VidHDcR6xDbZK'
    })
  }

  generateRequestInit(init) {
    return {
      method: init.method,
      body: JSON.stringify(init.body),
      headers: this.generateHeaders()
    }
  }

  generateOrigin() {
    return GM_STATE.omneo.apiBaseUrl
  }

  generateURL(endpoint) {
    const origin = this.generateOrigin()
    return new URL(`${origin}${endpoint}`)
  }

  async fetch(endpoint, _init, isSilent = false) {
    const url = this.generateURL(endpoint)
    const init = this.generateRequestInit(_init)
    const response = await fetch(url, init)
    try {
      return await response.json()
    } catch (error) {
      if (!isSilent) {
        console.error(error)
      }
      return undefined
    }
  }

  async checkAvailability(body) {
    return await this.fetch(OmneoPortal.ENDPOINT__AVAILABILITY, {
      method: 'POST',
      body
    })
  }

  // Based on create profile endpoint in Omneo API
  // https://docs.omneo.io/reference/createprofile
  async createAccount(data) {
    const response = await this.fetch(OmneoPortal.ENDPOINT__CREATE, {
      method: 'POST',
      body: {
        ...data,
        iFrameRedirectData: {
          iFrame: true,
          urlPath: '/account'
        }
      }
    })

    return response
  }

  /**
   *
   * Sends a 6 digit verification to the mobile_phone number provided
   *
   *
   * @param {string} mobile_phone
   * @returns
   */
  async getSMSAuthCode(mobile_phone) {
    return await this.fetch(OmneoPortal.ENDPOINT__SMS, {
      method: 'POST',
      body: {
        mobile_phone
      }
    })
  }

  /**
   *
   * Using the 6 digit code that is send by the getSMSAuthCode method.
   *
   *
   * @param {string} code
   * @returns {{data: {token: string}}}
   */
  async loginWithSMS(code) {
    return await this.fetch(OmneoPortal.ENDPOINT__SMS_RETRIEVE, {
      method: 'POST',
      body: {
        code
      }
    })
  }

  /**
   * Redirects to the authenticate the customers token.
   * @param {*} token
   */
  mobileLogin(token) {
    const url = `${this.generateOrigin()}/embed?token=${token}&mode=undefined&redirect=undefined&externalRedirect=null&iFrame=true&urlPath=/account&urlParams=undefined`
    window.location.href = url
  }

  getAccountPath() {
    const host = window.location.host
    return `${host}/account`
  }

  async sendLoginEmail(email, redirectUrl) {
    return await this.fetch(
      OmneoPortal.ENDPOINT__EMAIL,
      {
        method: 'POST',
        body: {
          email,
          iFrame: true,
          urlPath: redirectUrl || '/account'
        }
      },
      true
    )
  }
}
